/**
 * charma-size-guide.js
 * Вставляет таблицу подбора размера браслета на товарах с тегом "bracelets".
 */
(function () {
  'use strict';

  if (!window.location.pathname.includes('/products/')) return;

  var handle = window.location.pathname.split('/products/')[1].split('?')[0].split('/')[0];
  if (!handle) return;

  var CSS =
    '#ch-size-guide{border:0.5px solid #b2ccc9;border-radius:12px;overflow:hidden;margin-bottom:16px;font-family:inherit}' +
    '#ch-size-guide .csg-hero{background:#044a40;padding:13px 16px;display:flex;align-items:center;gap:12px}' +
    '#ch-size-guide .csg-hero-icon{width:38px;height:38px;border-radius:8px;border:1px solid rgba(255,255,255,.2);background:rgba(255,255,255,.08);display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:18px}' +
    '#ch-size-guide .csg-hero-title{font-size:13px;font-weight:700;color:#fff;line-height:1.3;margin-bottom:2px}' +
    '#ch-size-guide .csg-hero-sub{font-size:11.5px;color:#7ec4bc}' +
    '#ch-size-guide .csg-measure{background:#f3f8f7;padding:12px 16px;border-bottom:0.5px solid #dde9e8;display:flex;align-items:flex-start;gap:10px}' +
    '#ch-size-guide .csg-measure-ico{font-size:20px;flex-shrink:0;margin-top:1px}' +
    '#ch-size-guide .csg-measure-text{font-size:12px;color:#3a5a58;line-height:1.5}' +
    '#ch-size-guide .csg-measure-text strong{color:#044a40}' +
    '#ch-size-guide table{width:100%;border-collapse:collapse;font-size:12.5px}' +
    '#ch-size-guide thead tr{background:#e6f2f0}' +
    '#ch-size-guide thead th{padding:9px 12px;text-align:left;font-size:11px;font-weight:700;color:#3a5a58;letter-spacing:0.04em;text-transform:uppercase;border-bottom:0.5px solid #b2ccc9}' +
    '#ch-size-guide tbody tr{border-bottom:0.5px solid #eef2f1;transition:background .15s}' +
    '#ch-size-guide tbody tr:hover{background:#f7fbfa}' +
    '#ch-size-guide tbody tr.csg-popular{background:#fffbf0}' +
    '#ch-size-guide tbody tr.csg-popular td:first-child{position:relative}' +
    '#ch-size-guide td{padding:9px 12px;color:#2a2a2a;vertical-align:middle}' +
    '#ch-size-guide .csg-size{font-weight:700;color:#044a40;font-size:14px}' +
    '#ch-size-guide .csg-badge{display:inline-block;background:#f59e0b;color:#fff;font-size:10px;font-weight:700;border-radius:10px;padding:2px 7px;margin-left:6px;vertical-align:middle}' +
    '#ch-size-guide .csg-fit{display:inline-flex;align-items:center;gap:4px;font-size:11.5px;color:#5a7a78}' +
    '#ch-size-guide .csg-tip{background:#e6f2f0;padding:10px 14px;display:flex;align-items:center;gap:10px;border-top:0.5px solid #b2ccc9}' +
    '#ch-size-guide .csg-tip-ico{font-size:15px;flex-shrink:0}' +
    '#ch-size-guide .csg-tip-txt{font-size:11.5px;color:#023830;line-height:1.45}';

  var rows = [
    { wrist: '13 – 14', size: '16', fit: 'Priľahlé', popular: false },
    { wrist: '14 – 15', size: '17', fit: 'Pohodlné', popular: false },
    { wrist: '15 – 16', size: '18', fit: 'Pohodlné', popular: true },
    { wrist: '16 – 17', size: '19', fit: 'Pohodlné', popular: true },
    { wrist: '17 – 19', size: '20', fit: 'Voľné', popular: false },
  ];

  function buildBlock() {
    var rowsHTML = rows.map(function (r) {
      var badge = r.popular ? '<span class="csg-badge">Populárne</span>' : '';
      return '<tr' + (r.popular ? ' class="csg-popular"' : '') + '>' +
        '<td><span class="csg-size">' + r.size + ' cm</span>' + badge + '</td>' +
        '<td>' + r.wrist + ' cm</td>' +
        '<td><span class="csg-fit">' + r.fit + '</span></td>' +
        '</tr>';
    }).join('');

    return '<div id="ch-size-guide">' +
      '<div class="csg-hero">' +
        '<div class="csg-hero-icon">📏</div>' +
        '<div>' +
          '<div class="csg-hero-title">Ako vybrať správnu veľkosť náramku</div>' +
          '<div class="csg-hero-sub">Odmerte si obvod zápästia a nájdite svoj rozmer</div>' +
        '</div>' +
      '</div>' +
      '<div class="csg-measure">' +
        '<div class="csg-measure-ico">✂️</div>' +
        '<div class="csg-measure-text">' +
          'Omotajte <strong>meter alebo kúsok papiera</strong> tesne okolo zápästia. ' +
          'Odmerajte dĺžku v centimetroch — to je obvod vášho zápästia.' +
        '</div>' +
      '</div>' +
      '<table>' +
        '<thead><tr>' +
          '<th>Veľkosť náramku</th>' +
          '<th>Obvod zápästia</th>' +
          '<th>Typ nosenia</th>' +
        '</tr></thead>' +
        '<tbody>' + rowsHTML + '</tbody>' +
      '</table>' +
      '<div class="csg-tip">' +
        '<div class="csg-tip-ico">💡</div>' +
        '<div class="csg-tip-txt">Pre náramky so šarmami odporúčame zvoliť o <strong>1–2 cm väčší</strong> rozmer, aby šarmy voľne viseli.</div>' +
      '</div>' +
    '</div>';
  }

  function inject() {
    if (document.getElementById('ch-size-guide')) return;

    var anchor = document.querySelector('ul.icon-with-text');
    if (!anchor) return;

    if (!document.getElementById('ch-size-guide-style')) {
      var st = document.createElement('style');
      st.id = 'ch-size-guide-style';
      st.textContent = CSS;
      document.head.appendChild(st);
    }

    var blockHTML = buildBlock();
    if ((document.documentElement.lang || '').toLowerCase().indexOf('pl') === 0) { var plCopies = {"Ako vybrať správnu veľkosť náramku":"Jak wybrać rozmiar bransoletki","Odmerte si obvod zápästia a nájdite svoj rozmer":"Zmierz obwód nadgarstka i znajdź swój rozmiar","Omotajte <strong>meter alebo kúsok papiera</strong> tesne okolo zápästia. ":"Owiń <strong>miarkę lub pasek papieru</strong> wokół nadgarstka. ","Odmerajte dĺžku v centimetroch — to je obvod vášho zápästia.":"Zmierz długość w centymetrach — to obwód Twojego nadgarstka.","Veľkosť náramku":"Rozmiar bransoletki","Obvod zápästia":"Obwód nadgarstka","Typ nosenia":"Dopasowanie","Populárne":"Popularny","Priľahlé":"Przylegające","Pohodlné":"Wygodne","Voľné":"Luźne","Pre náramky so šarmami odporúčame zvoliť o <strong>1–2 cm väčší</strong> rozmer, aby šarmy voľne viseli.":"Do bransoletek z charmsami zalecamy rozmiar <strong>o 1–2 cm większy</strong>, aby charmsy mogły swobodnie zwisać."}; Object.keys(plCopies).sort(function(a,b){return b.length-a.length;}).forEach(function(s){ blockHTML = blockHTML.split(s).join(plCopies[s]); }); }
    anchor.insertAdjacentHTML('beforebegin', blockHTML);
  }

  function tryInject() {
    inject();
    if (!document.getElementById('ch-size-guide')) {
      setTimeout(inject, 300);
      setTimeout(inject, 800);
      setTimeout(inject, 1500);
    }
  }

  // Check tag "bracelets" via product JSON
  fetch('/products/' + handle + '.js')
    .then(function (r) { return r.json(); })
    .then(function (product) {
      var tags = product.tags || [];
      if (typeof tags === 'string') tags = tags.split(',').map(function (t) { return t.trim(); });
      if (tags.indexOf('ktb') === -1) return;

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', tryInject);
      } else {
        tryInject();
      }
    })
    .catch(function () {});
})();
